import { render, staticRenderFns } from "./addUs.vue?vue&type=template&id=136e2e39"
import script from "./addUs.vue?vue&type=script&lang=js"
export * from "./addUs.vue?vue&type=script&lang=js"
import style0 from "./addUs.vue?vue&type=style&index=0&id=136e2e39&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports